import { pipe } from 'ramda';

import { throttleAndWaitPrev } from './throttleAndWaitPrev';
import { prevent } from './prevent';

/**
 * 이벤트 처리기를 받아 `preventDefault()`와 `throttle(1000)`을 적용해 반환한다.
 *
 * `beforeExecute`에 함수를 넘겨주면 처리기를 호출하기 전에 우선 호출한다.
 *
 * `beforeExecute`가 비동기 함수라면 반환하는 `Promise`가 해소되거나 오류나기 전에 처리기를 호출하지 않으므로, 타임아웃은 직접 구현해야 한다.
 * @param handler 실행할 이벤트 처리기.
 * @param beforeExecute 이벤트 처리기 전에 호출할 (비동기)함수.
 */
export const preventAndThrottle = <E extends Event | React.SyntheticEvent>(
  handler: (event: E) => void,
  beforeExecute?: (event: E) => void | Promise<void>,
): ((e: E) => void | Promise<void>) => {
  const throttledHandler = throttleAndWaitPrev(handler, beforeExecute);
  return pipe(prevent, throttledHandler);
};
